import {
    useEffect,
    useRef,
    useState,
} from "react";

export default function ZoomImage({

    image,

    alt = "",

    hoverZoom = true,

    wheelZoom = false,

    draggable = false,

    maxScale = 4,

}) {

    const wrapperRef = useRef(null);

    const imageRef = useRef(null);

    const frameRef = useRef(null);

    const scaleRef = useRef(1);

    const translateRef = useRef({
        x: 0,
        y: 0,
    });

    const draggingRef = useRef(false);

    const lastMouseRef = useRef({
        x: 0,
        y: 0,
    });

    const [loaded, setLoaded] = useState(false);

    useEffect(() => {

        setLoaded(false);

        scaleRef.current = 1;

        translateRef.current = {
            x: 0,
            y: 0,
        };

    }, [image]);

    const updateTransform = () => {

        clampTranslate();

        if (scaleRef.current > 1) {

            wrapperRef.current.classList.add("zoomed");

        } else {

            wrapperRef.current.classList.remove("zoomed");

        }

        imageRef.current.style.transform =
            `translate(${translateRef.current.x}px, ${translateRef.current.y}px)
         scale(${scaleRef.current})`;



    };
    const clampTranslate = () => {

        if (!wrapperRef.current || !imageRef.current)
            return;

        const wrapper = wrapperRef.current.getBoundingClientRect();

        const image = imageRef.current.getBoundingClientRect();

        const scaledWidth = image.width * scaleRef.current;
        const scaledHeight = image.height * scaleRef.current;

        const maxX = Math.max(0, (scaledWidth - wrapper.width) / 2);
        const maxY = Math.max(0, (scaledHeight - wrapper.height) / 2);

        translateRef.current.x = Math.min(
            maxX,
            Math.max(-maxX, translateRef.current.x)
        );

        translateRef.current.y = Math.min(
            maxY,
            Math.max(-maxY, translateRef.current.y)
        );

    };

    const handleMouseMove = (e) => {

        if (!hoverZoom)
            return;

        if (draggingRef.current)
            return;

        if (frameRef.current)
            cancelAnimationFrame(frameRef.current);

        frameRef.current = requestAnimationFrame(() => {

            const rect =
                wrapperRef.current.getBoundingClientRect();

            const x =
                ((e.clientX - rect.left) / rect.width) * 100;

            const y =
                ((e.clientY - rect.top) / rect.height) * 100;

            imageRef.current.style.transformOrigin =
                `${x}% ${y}%`;

            if (scaleRef.current === 1)
                scaleRef.current = 2;

            updateTransform();

        });

    };
    const handleLeave = () => {

        if (draggingRef.current)
            return;

        scaleRef.current = 1;

        translateRef.current = {
            x: 0,
            y: 0,
        };

        imageRef.current.style.transformOrigin =
            "center center";

        updateTransform();

    };

    const handleWheel = (e) => {

        if (!wheelZoom)
            return;

        e.preventDefault();

        const direction = e.deltaY > 0 ? -0.2 : 0.2;

        const newScale = Math.min(
            maxScale,
            Math.max(1, scaleRef.current + direction)
        );

        if (newScale === scaleRef.current)
            return;

        scaleRef.current = newScale;

        updateTransform();

    };
    const handleMouseDown = (e) => {

        if (!draggable)
            return;

        if (scaleRef.current <= 1)
            return;

        draggingRef.current = true;

        wrapperRef.current.classList.add("dragging");

        lastMouseRef.current = {

            x: e.clientX,
            y: e.clientY,

        };

    };

    const handleDrag = (e) => {

        if (!draggingRef.current)
            return;

        const dx =
            e.clientX - lastMouseRef.current.x;

        const dy =
            e.clientY - lastMouseRef.current.y;

        translateRef.current.x += dx;

        translateRef.current.y += dy;

        lastMouseRef.current = {

            x: e.clientX,

            y: e.clientY,

        };

        updateTransform();

    };

    const handleMouseUp = () => {

        draggingRef.current = false;

        wrapperRef.current.classList.remove("dragging");

    };

    const handleDoubleClick = () => {

        scaleRef.current = 1;

        translateRef.current = {

            x: 0,

            y: 0,

        };

        imageRef.current.style.transformOrigin =
            "center center";

        updateTransform();

    };

    if (!image) return null;

    return (

        <div

            ref={wrapperRef}

            className="zoom-wrapper"

            onMouseMove={handleMouseMove}

            onMouseLeave={handleLeave}

            onWheel={handleWheel}

            onMouseDown={handleMouseDown}

            onMouseMoveCapture={handleDrag}

            onMouseUp={handleMouseUp}

            onDoubleClick={handleDoubleClick}

        >

            {!loaded &&

                <div className="zoom-loading" />

            }

 <img
    ref={imageRef}
    src={image?.url}
    alt={alt}
    draggable={false}
    onLoad={() => setLoaded(true)}
/>

        </div>

    );

}
